// import React from 'react';
// import { useState } from 'react';
// import shape1 from '../../images/shapes/shape_circle_1.webp';
// import shape2 from '../../images/shapes/shape_section_divider_2.svg';

// const roadmapData = [
//   {
//     badge: "Q1 - 2024",
//     title: "Foundation & Vision Alignment",
//     items: [
//       "Analyzed privacy, identity, and decentralized tech trends for real-world gaps.",
//       "Defined Panda Sovereign’s mission: secure, gadget-free, user-first identity layer.",
//       "Outlined tokenomics and strategic objectives in a transparent whitepaper."
//     ]
//   },
//   {
//     badge: "Q2 - 2024",
//     title: "Community & Ecosystem Engagement",
//     items: [
//       "Initiated organic community building through socials, AMAs, and forums.",
//       "Early supporters rewarded via secure airdrops and participation incentives.",
//       // "Offer rewards and bonuses to early supporters to build trust.",
//       "Established a feedback loop to shape the platform with real users."
//     ]
//   },
//   {
//     badge: "Q3 - 2025",
//     // badge: "Q3 - Q2 2025",
//     title: "Sovereign Launch & Growth Acceleration",
//     items: [
//       "Launched sovereign with strong privacy-first messaging and developer appeal.",
//       "Secured early contributions, building momentum and long-term believers.",
//       "Listed $PANDA on major exchanges to increase visibility and adoption.",
//       "Rolled out core features: IDV, smart contract tools, and dashboards."
//     ]
//   },
//   {
//     badge: "Q4 - 2025",
//     title: "Token Distribution & Utility Expansion",
//     items: [
//       "Distributed tokens to public contributors, partners, and core team.",
//       "Allocated ecosystem growth pool to reward developers and ambassadors.",
//       "Introduced staking, governance, and ecosystem utility for $PANDA holders.",
//       "Supported marketing and community outreach through incentivized programs."
//     ]
//   }
// ];

// const RoadmapSection = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const handleMouseOver = (index) => {
//     setActiveIndex(index);
//   };

//   return (
//     <section id="id_ico_roadmap_section" className="ico_roadmap_section section_space mt-lg-5 section_decoration">
//       <div className="container">
//         <div className="ico_heading_block text-center mt-lg-5 pt-lg-5" data-aos="fade-up" data-aos-duration="600">
//           <h2 className="heading_text mb-0">Roadmap</h2>
//         </div>

//         <div className="ico_roadmap_flexbox" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
//           {roadmapData.map((block, index) => (
//             <div
//               key={index}
//               className={`roadmap_block ${activeIndex === index ? "active" : ""}`}
//               onMouseOver={() => handleMouseOver(index)}
//             >
//               <div className="badge">{block.badge}</div>
//               <h3 className="heading_text">{block.title}</h3>
//               <ul className="iconlist_block unordered_list_block">
//                 {block.items.map((item, itemIndex) => (
//                   <li key={itemIndex}>
//                     <span className="iconlist_icon">
//                       <i className="fa-solid fa-circle"></i>
//                     </span>
//                     <span className="iconlist_label">{item}</span>
//                   </li>
//                 ))}
//               </ul>
//               <div className="hover_shape">
//                 <img src={shape1} alt="Shape Circle" />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="decoration_item shape_divider_1">
//         <img src={shape2} alt="Shape Divider" />
//       </div>
//     </section>
//   );
// };

// export default RoadmapSection;

"use client"
import { useState } from "react"
import { useApi } from "../../hooks/useApi"
import shape1 from "../../images/shapes/shape_circle_1.webp"
import shape2 from "../../images/shapes/shape_section_divider_2.svg"

const RoadmapSection = () => {
  const [activeIndex, setActiveIndex] = useState(null)
  const { data: roadmapData, loading, error } = useApi("/roadmap")
console.log(roadmapData,"kkkkkk")
  const handleMouseOver = (index) => {
    setActiveIndex(index)
  }

  if (loading) {
    return (
      <section id="id_ico_roadmap_section" className="ico_roadmap_section section_space mt-lg-5 section_decoration">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (error || !roadmapData) {
    return null
  }

  return (
    <section id="id_ico_roadmap_section" className="ico_roadmap_section section_space mt-lg-5 section_decoration">
      <div className="container">
        <div className="ico_heading_block text-center mt-lg-5 pt-lg-5" data-aos="fade-up" data-aos-duration="600">
          <h2 className="heading_text mb-0">{roadmapData.heading}</h2>
        </div>

        <div className="ico_roadmap_flexbox" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
          {roadmapData.roadmapData?.map((block, index) => (
            <div
              key={index}
              className={`roadmap_block ${activeIndex === index ? "active" : ""}`}
              onMouseOver={() => handleMouseOver(index)}
            >
              <div className="badge">{block.badge}</div>
              <h3 className="heading_text">{block.title}</h3>
              <ul className="iconlist_block unordered_list_block">
                {block.items?.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <span className="iconlist_icon">
                      <i className="fa-solid fa-circle"></i>
                    </span>
                    <span className="iconlist_label">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="hover_shape">
                <img src={shape1 || "/placeholder.svg"} alt="Shape Circle" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="decoration_item shape_divider_1">
        <img src={shape2 || "/placeholder.svg"} alt="Shape Divider" />
      </div>
    </section>
  )
}

export default RoadmapSection
